import "popper.js/dist/popper.min.js";

$(function () {
  $("[data-tooltip-country]").each(function(){
    let countryCode = $(this).attr("data-tooltip-country-code");
    let countryLabel = $(this).attr("data-tooltip-country-name");
    $("[data-svg-world-map] #" + countryCode).addClass("has-events").popover({trigger:'hover', placement:'auto', html: true, content: $(this).html()});
  });
});
